export default __webpack_public_path__ + "static/media/Group 2018.30b41a65.svg";